import {useEffect} from "react";
import {useEnvironment} from "./UseEnvironment";
import {useLocation, useNavigate} from "react-router-dom";
import _device_service from "../services/DeviceService";

export function useBrowserNavigation(callback: (location: string) => void, scrollToTop: boolean = true): void {
    const location = useLocation();
    const client = useEnvironment().targetClient;
    const navigateTo = useNavigate();

    useEffect(() => {
        let url = location.pathname;

        if (url.startsWith(client) && !url.startsWith('/')) {
            url = client + url;
        }

        if (callback) {
            callback(location.pathname);
        }

        navigateTo(url, {replace: true});
        if (scrollToTop) {
            _device_service.goToTop();
        }
    }, [location.pathname]);
}

export default useBrowserNavigation;